import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconBookmarkFilled = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0002 15.8956L7.91473 18.8137C7.25287 19.2865 6.3335 18.8134 6.3335 18V7.33333C6.3335 6.04467 7.37816 5 8.66683 5H15.3335C16.6222 5 17.6668 6.04467 17.6668 7.33333V18C17.6668 18.8134 16.7475 19.2865 16.0856 18.8137L12.0002 15.8956Z"
        />
      </svg>
    );
  }
);
